// eslint-disable-next-line no-use-before-define
var site = site || {};

site.userInfoCookie = site.userInfoCookie || {};
site.userInfoCookie.getValue = site.userInfoCookie.getValue ||
  function () {
    return '';
  };

(function ($) {
  Drupal.behaviors.loyaltyDynamicJoinForm = {
    attach: function (context) {
      const signedIn = site?.userInfoCookie?.getValue('signed_in') === '1';
      const isLoyalty = site?.userInfoCookie?.getValue('is_loyalty_member') === '1';
      const $guest = $('.js-guest', context);
      const $loggedInLoyalty = $('.js-logged-in-loyalty', context);
      const $loggedInNonLoyalty = $('.js-logged-in-non-loyalty', context);

      if (signedIn && isLoyalty) {
        $guest.addClass('hidden');
        $loggedInNonLoyalty.addClass('hidden');
        $loggedInLoyalty.removeClass('hidden');
      } else if (signedIn && !isLoyalty) {
        $guest.addClass('hidden');
        $loggedInLoyalty.addClass('hidden');
        $loggedInNonLoyalty.removeClass('hidden');
      } else {
        $loggedInLoyalty.addClass('hidden');
        $loggedInNonLoyalty.addClass('hidden');
        $guest.removeClass('hidden');
      }
    }
  };
})(jQuery);
